import { CreateVisitState } from './types';
import { combineReducers } from 'redux';
import { cartReducer } from './cart/reducer';
import { patientReducer } from './patient/reducer';

export const createVisitReducer = combineReducers<CreateVisitState>({
  cart: cartReducer,
  patientState: patientReducer,
});
